module.exports = __webpack_public_path__ + "img/DJI_0523-lazy.10b10513.jpg";